<select [(ngModel)]="fields.value" (change)="checkValidation(fields,true)">
    <!-- <option selected disabled value="">{{fields.label}}</option> -->
    <option *ngFor="let elem of fields.values" [value]="elem.key">
        {{ elem.value }}
      </option>
</select>
<label class="label visible">{{fields.label}}</label>